import { AsciiText } from '../framework/AsciiText';
export class Monoprice {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.beep = true;
        this.routes = [0, 0, 0, 0];
        this.asyncHandlers = [
            {
                name: 'beepGet',
                regExp: /\xa5\x5b\x01\x0b\x00{8}[\s\S]/,
                callback: (match) => {
                    const code = this.beep ? 0x00 : 0xff;
                    this.socket.send(this.makeCommand([0xa5, 0x5b, 0x01, 0x0b, 0x00, 0x00, code]));
                },
            },
            {
                name: 'beepSet',
                regExp: /\xa5\x5b\x06\x01(\x0f|\xf0)\x00{7}[\s\S]/,
                callback: (match) => {
                    this.beep = match[1].charCodeAt(0) === 0x0f;
                    this.socket.send(this.makeCommand([0xa5, 0x5b, 0x06, 0x01]));
                },
            },
            {
                name: 'routeGet',
                regExp: /\xa5\x5b\x02\x01([\s\S])\x00{7}[\s\S]/,
                callback: (match) => {
                    const outPort = match[1].charCodeAt(0);
                    if (outPort < 1 || outPort > 4) {
                        this.log.error(`output port out of range: ${outPort}`);
                        return;
                    }
                    const inPort = this.routes[outPort - 1] + 1;
                    this.socket.send(this.makeCommand([0xa5, 0x5b, 0x02, 0x01, outPort, 0x00, inPort]));
                },
            },
            {
                name: 'routeSet',
                regExp: /\xa5\x5b\x02\x03([\s\S])\x00([\s\S])\x00{5}[\s\S]/,
                callback: (match) => {
                    const inPort = match[1].charCodeAt(0);
                    const outPort = match[2].charCodeAt(0);
                    if (inPort < 1 || inPort > 4) {
                        this.log.error(`input port out of rante: ${inPort}`);
                        return;
                    }
                    if (outPort < 1 || outPort > 4) {
                        this.log.error(`output port out of range: ${outPort}`);
                        return;
                    }
                    this.socket.send(this.makeCommand([0xa5, 0x5b, 0x02, 0x03, 0x00, 0x00, outPort]));
                },
            },
        ];
    }
    makeCommand(data) {
        const pad = 12 - data.length;
        for (let i = 0; i < pad; i++) {
            data.push(0);
        }
        let checksum = 0;
        for (const datum of data) {
            checksum += datum;
        }
        data.push((256 - checksum) & 0x00ff);
        return AsciiText.decode(data);
    }
}
Monoprice.emulatorType = 'socketEmulator';
Monoprice.key = '-LX9V2m1O-7W947NVpT0';
